import { render, staticRenderFns } from "./VanFieldCheckbox.vue?vue&type=template&id=f7bb6f70&scoped=true"
import script from "./VanFieldCheckbox.vue?vue&type=script&lang=js"
export * from "./VanFieldCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VanFieldCheckbox.vue?vue&type=style&index=0&id=f7bb6f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bb6f70",
  null
  
)

export default component.exports